var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',{staticClass:"welcome-text"},[_vm._v("Hello "+_vm._s(_vm.user.email))])])
}
var staticRenderFns = []

export { render, staticRenderFns }